import React__default, { useContext, useMemo } from 'react';
import { L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import { h as getClassName, B as isEditedMessage } from '../index-579ca9d7.js';
import { a as LocalizationContext } from '../LocalizationContext-a82461b5.js';
import { t as tokenizeMessage } from '../tokenize-c718324d.js';
import { T as TextFragment } from '../index-a2bb2783.js';
import { T as TEXT_MESSAGE_BODY_CLASSNAME } from '../consts-7693b8d3.js';
import 'prop-types';
import '../stringSet-b60e9529.js';
import '../_rollupPluginBabelHelpers-05128ded.js';
import '../utils/message/getOutgoingMessageState.js';
import '../index-6add7940.js';
import '../index.module-4f1cd64e.js';
import '../Message/context.js';
import './MentionLabel.js';
import './ContextMenu.js';
import 'react-dom';
import './SortByRow.js';
import '../uuid-717930b4.js';
import './UserProfile.js';
import '../UserProfileContext-f3f446d2.js';
import '../sendbirdSelectors.js';
import '../topics-eb548880.js';
import '../utils-e0c7329c.js';
import './Avatar.js';
import './ImageRenderer.js';
import './Icon.js';
import './Button.js';
import '../useSendbirdStateContext.js';
import '../withSendbird.js';
import './LinkLabel.js';
function TextMessageItemBody(_ref) {
  var _message$mentionedMes, _message$mentionedUse, _message$reactions;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    message = _ref.message,
    _ref$isByMe = _ref.isByMe,
    isByMe = _ref$isByMe === void 0 ? false : _ref$isByMe,
    _ref$mouseHover = _ref.mouseHover,
    mouseHover = _ref$mouseHover === void 0 ? false : _ref$mouseHover,
    _ref$isMentionEnabled = _ref.isMentionEnabled,
    isMentionEnabled = _ref$isMentionEnabled === void 0 ? false : _ref$isMentionEnabled,
    _ref$isReactionEnable = _ref.isReactionEnabled,
    isReactionEnabled = _ref$isReactionEnable === void 0 ? false : _ref$isReactionEnable;
  var _useContext = useContext(LocalizationContext),
    stringSet = _useContext.stringSet;
  var isMessageMentioned = isMentionEnabled && (message === null || message === void 0 ? void 0 : (_message$mentionedMes = message.mentionedMessageTemplate) === null || _message$mentionedMes === void 0 ? void 0 : _message$mentionedMes.length) > 0 && (message === null || message === void 0 ? void 0 : (_message$mentionedUse = message.mentionedUsers) === null || _message$mentionedUse === void 0 ? void 0 : _message$mentionedUse.length) > 0;
  var tokens = useMemo(function () {
    if (isMessageMentioned) {
      return tokenizeMessage({
        mentionedUsers: message === null || message === void 0 ? void 0 : message.mentionedUsers,
        messageText: message === null || message === void 0 ? void 0 : message.mentionedMessageTemplate
      });
    }
    return tokenizeMessage({
      messageText: message === null || message === void 0 ? void 0 : message.message
    });
  }, [message === null || message === void 0 ? void 0 : message.updatedAt]);
  return /*#__PURE__*/React__default.createElement(Label, {
    type: LabelTypography.BODY_1,
    color: isByMe ? LabelColors.ONCONTENT_1 : LabelColors.ONBACKGROUND_1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: getClassName([className, TEXT_MESSAGE_BODY_CLASSNAME, isByMe ? 'outgoing' : 'incoming', mouseHover ? 'mouse-hover' : '', isReactionEnabled && (message === null || message === void 0 ? void 0 : (_message$reactions = message.reactions) === null || _message$reactions === void 0 ? void 0 : _message$reactions.length) > 0 ? 'reactions' : ''])
  }, /*#__PURE__*/React__default.createElement(TextFragment, {
    tokens: tokens
  }), isEditedMessage(message) && /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-text-message-item-body__message edited",
    type: LabelTypography.BODY_1,
    color: isByMe ? LabelColors.ONCONTENT_2 : LabelColors.ONBACKGROUND_2
  }, " ".concat(stringSet.MESSAGE_EDITED, " "))));
}
export { TextMessageItemBody as default };